import {useMutation} from '@github-ui/react-query'
import {apiCreateLabel, type CreateLabelRequest} from '../api/api-create-label'
import {parseGraphQLResponse} from '@github-ui/item-picker-base/api/graphql'

export const useCreateLabelMutation = () => {
  return useMutation({
    mutationFn: async (request: CreateLabelRequest) => {
      const responseJson = await apiCreateLabel(request)
      const responseData = parseGraphQLResponse(responseJson)
      return responseData.data.createLabel?.label ?? null
    },
  })
}
